// @ts-nocheck
import { uniq } from 'lodash';

const timeRangeOptionIds = ['fromStart', 'today', 'yesterday', 'last7Days', 'thisMonth', 'lastMonth', 'customDates'];

const getSelectorValue = (options, id) => (options.length ? options.filter(cO => cO.id === id) : []);

const formatTimeFrame = (initial, end) => ({
  beginDate: moment.utc(initial).startOf('day').format('YYYY-MM-DD'),
  endDate: moment.utc(end).startOf('day').format('YYYY-MM-DD')
});

const isDisabledCartographyLevelSelector = countries => uniq(countries).length === -1;

const getCommonCountryLevels = countries => {
  return countries[0].tagsConfig
    .filter(tag => tag.id !== 'level0' && tag.reportingMapEventsEnable)
    .sort((a, b) => a.order - b.order);
};

export {
  formatTimeFrame,
  getCommonCountryLevels,
  getSelectorValue,
  isDisabledCartographyLevelSelector,
  timeRangeOptionIds
};
